module.exports = __webpack_public_path__ + "img/sc.049e7208.svg";